var _rect, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgQrButtonImage(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 8,
    fill: "#202B67"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_14508_54663)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.875 7.5H7.5V10.875H10.875V7.5ZM10.3125 10.3125H8.0625V8.0625H10.3125V10.3125Z",
    fill: "#F6F7FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.625 8.625H9.75V9.75H8.625V8.625ZM7.5 16.5H10.875V13.125H7.5V16.5ZM8.0625 13.6875H10.3125V15.9375H8.0625V13.6875Z",
    fill: "#F6F7FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.625 14.25H9.75V15.375H8.625V14.25ZM13.125 7.5V10.875H16.5V7.5H13.125ZM15.9375 10.3125H13.6875V8.0625H15.9375V10.3125Z",
    fill: "#F6F7FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.25 8.625H15.375V9.75H14.25V8.625ZM8.625 11.4375H7.5V12.5625H9.1875V12H8.625V11.4375ZM11.4375 12.5625H12.5625V13.6875H11.4375V12.5625ZM9.1875 11.4375H10.3125V12H9.1875V11.4375ZM12.5625 14.25H11.4375V14.8125H12V15.375H12.5625V14.8125V14.25ZM10.875 11.4375V12H10.3125V12.5625H11.4375V11.4375H10.875ZM12 9.75H12.5625V10.875H12V9.75ZM12.5625 12V12.5625H13.6875V11.4375H12V12H12.5625ZM11.4375 10.875H12V11.4375H11.4375V10.875ZM12.5625 15.375H13.6875V16.5H12.5625V15.375ZM11.4375 15.375H12V16.5H11.4375V15.375ZM12.5625 13.6875H13.125V14.25H12.5625V13.6875ZM12.5625 9.1875V8.0625H12V7.5H11.4375V9.75H12V9.1875H12.5625ZM14.25 15.375H14.8125V16.5H14.25V15.375ZM14.25 14.25H15.375V14.8125H14.25V14.25ZM13.6875 14.8125H14.25V15.375H13.6875V14.8125ZM13.125 14.25H13.6875V14.8125H13.125V14.25ZM15.375 13.125V13.6875H15.9375V14.25H16.5V13.125H15.9375H15.375ZM15.9375 14.8125H15.375V16.5H16.5V15.375H15.9375V14.8125ZM13.125 13.125V13.6875H14.8125V12.5625H13.6875V13.125H13.125ZM14.25 11.4375V12H15.375V12.5625H16.5V11.4375H15.375H14.25Z",
    fill: "#F6F7FF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_14508_54663"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 9,
    height: 9,
    fill: "white",
    transform: "translate(7.5 7.5)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgQrButtonImage);
export default __webpack_public_path__ + "static/media/qr-button-image.308daa5245fa3660c7b860cce35e0c91.svg";
export { ForwardRef as ReactComponent };